import React, {useState} from "react";
import {Box, Button, Column, Columns, Field, Input, TextArea, Title} from "@allxsmith/bestax-bulma";
import {fixed} from "lodash/fp/_falseOptions";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";


export default function NewFixedExpense({onSave, departments, departmentObjects}){
    const [fixedExpense, setFixedExpense] = useState({
        description: "",
        supplier: {},
        yearly_amount: 0,
        department: departments[0],
        start_date: null,
        renewal_date: null
    });

    const clear = () => {
        setFixedExpense({
            description: "",
            supplier: {},
            yearly_amount: 0,
            department: departments[0],
            start_date: null,
            renewal_date: null
        });
    };

    const [isLoading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [, setTypeahead] = useState();

    const handleSearch = e => {
        setLoading(true);
        axios.get(`/api/contacts?contact_type=SP&search=${e}`).then(resp => {
          setSearchData(resp.data.results);
          setLoading(false);
        });
    };

    const onChange = e => {
        let newFixedExpense = {...fixedExpense};
        newFixedExpense[e.target.name] = e.target.value;
        setFixedExpense(newFixedExpense);
    }

    const onDepartmentChange = e => {
        const toUpdate = {
            target: {
                name: "department",
                value: departmentObjects[e.target.value]
            }
        };
        onChange(toUpdate);
    }

    const onSupplierChange = e => {
        const toUpdate = {
            target: {
                name: "supplier",
                value: e[0]
            }
        };
        onChange(toUpdate);
    }

    return (
        <Box>
            <details>
                <summary><Title>New Fixed Expense</Title></summary>
            <Columns isMultiline>
                <Column>
                    <label className="label">Department</label>
                    <DepartmentSelector
                        options={departments}
                        value={fixedExpense.department}
                        blank={true}
                        onChange={onDepartmentChange}
                        name={"department"}
                        editable={true}
                        disabled={false}
                    />
                </Column>
                <Column>
                    <label className="label">Supplier</label>
                    <Field className="has-addons">
                      <AsyncTypeahead
                          useCache={false}
                          id="typeahead"
                          labelKey="display_name"
                          minLength={2}
                          name={"supplier"}
                          onSearch={handleSearch}
                          onChange={onSupplierChange}
                          placeholder={"Search Supplier"}
                          options={searchData}
                          ref={typeahead => setTypeahead(typeahead)}
                          className="typeahead"
                          isLoading={isLoading}
                          selected={
                            fixedExpense.supplier && fixedExpense.supplier.id ? [fixedExpense.supplier] : []
                          }
                      />
                    </Field>
                </Column>
                <Column>
                    <label className="label">Description</label>
                    <TextArea
                        value={fixedExpense.description}
                        onChange={onChange}
                        name={"description"}
                    />
                </Column>
                <Column>
                    <label className="label">Start Date</label>
                    <Input
                        type={"date"}
                        onChange={onChange}
                        name={"start_date"}
                        value={fixedExpense.start_date}
                    />
                </Column>
                <Column>
                    <label className="label">Renewal Date</label>
                    <Input
                        type={"date"}
                        onChange={onChange}
                        name={"renewal_date"}
                        value={fixedExpense.renewal_date}
                    />
                </Column>
                <Column>
                    <label className="label">Yearly Amount (£)</label>
                    <Input
                        type={"number"}
                        value={fixedExpense.yearly_amount}
                        onChange={onChange}
                        name={"yearly_amount"}
                    />
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Button
                        color={"success"}
                        onClick={() => onSave(fixedExpense)}
                    >
                        Create
                    </Button>
                </Column>
            </Columns>
            </details>
        </Box>
    );


}